import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import { Button, Grid, MenuItem } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import { useForm } from '../../../../hooks/useForm';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import { AlertFinalizadoStepper } from '../../../stepper/AlertFinalizadoStepper';
import { agregarEditarCuota } from "../../../../actions/facturacion/cuotas";
import { TIPO_AFILIACION } from '../../../../utils/constants';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 20,
    },
    grid: {
        padding: 15,
        marginTop: 10,
        paddingLeft: 50,
        paddingRight: 50
    },
    gridBackground: {
        backgroundColor: 'white',
    },
    botonera: {
        marginTop: 25,
        marginLeft: 55,
        paddingBottom: 13
    },
    roles: {
        float: "left",
        marginLeft: 15,
    },
    formControl: {
        marginTop: 15,
        width: 183,
        textAlign: "left"
    },
}));

export const Cuota = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { seleccionado } = useSelector((state) => state.cuotas);

    const [ formValues, handleInputChange ] = useForm( seleccionado );
    const { idTipoAfiliacion, sitRevistaAportes, descripcion, edadDesde, edadHasta, fechaDesde, fechaHasta, cuota, cuotaFamiliar, idCuota } = formValues;
    const [ openQuestion, setOpenQuestion ] = useState(false);

    const handleSave = () => {
        dispatch( 
            agregarEditarCuota(
                { idTipoAfiliacion, sitRevistaAportes, descripcion, edadDesde, edadHasta, fechaDesde, fechaHasta, cuota, cuotaFamiliar, idCuota }
                ,closeModal
            )
        );
    }

    const closeModal = () => {
        setOpenQuestion(false);
    }

    return ( 
        <>
            {seleccionado && (
                <>
                    <ValidatorForm onSubmit={() => setOpenQuestion(true)} className={classes.root}>
                        <Grid item container justify='center'>
                            <Grid item xs={8} className={classes.gridBackground}>
                                <Grid item container >
                                    <Grid item xs={12} className={classes.grid} style={{paddingTop: 0}}>
                                        <TextValidator
                                            fullWidth
                                            margin="normal"
                                            label="Cuota"
                                            name="descripcion"
                                            value={descripcion}
                                            autoComplete="off"
                                            multiline={true}
                                            inputProps={{ maxLength: 250 }}
                                            onChange={handleInputChange}
                                            validators={["required"]}
                                            errorMessages={["Este campo es obligatorio"]}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="center" justify="center" >
                                    <Grid item xs={12} md={4} >
                                        <SelectValidator
                                            style={{minWidth: 238}}
                                            margin="normal"
                                            value={idTipoAfiliacion}
                                            name="idTipoAfiliacion"
                                            onChange={handleInputChange}
                                            InputLabelProps={{ shrink: true }}  
                                            label="Tipo Afiliación"
                                            validators={['required']}
                                            errorMessages={['Seleccione una opción']}
                                        >
                                            <MenuItem value="">
                                                <em>Seleccione</em>
                                            </MenuItem>
                                            <MenuItem value={TIPO_AFILIACION.DJ}>DJ</MenuItem>
                                            <MenuItem value={TIPO_AFILIACION.TEMPORARIO_CON_CUOTA}>TEMPORARIO CON CUOTA</MenuItem>
                                            <MenuItem value={TIPO_AFILIACION.TEMPORARIO}>TEMPORARIO</MenuItem>
                                            <MenuItem value={TIPO_AFILIACION.ADHERENTE}>ADHERENTE</MenuItem>
                                        </SelectValidator>
                                    </Grid>
                                    <Grid item xs={12} md={4} >
                                        <TextValidator
                                            style={{minWidth: 237}}
                                            label="Situación Revista Aportes"
                                            name="sitRevistaAportes"
                                            onChange={handleInputChange}
                                            className={classes.withoutLabel}
                                            InputLabelProps={{ shrink: true }}  
                                            value={sitRevistaAportes}
                                            validators={['matchRegexp:^[0-9]+$']}
                                            errorMessages={['Solo se permiten números positivos enteros']}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="center" justify="center" >
                                    <Grid item xs={12} md={4} >
                                        <TextValidator
                                            style={{minWidth: 237}}
                                            label="Edad Desde"
                                            name="edadDesde"
                                            onChange={handleInputChange}
                                            className={classes.withoutLabel}
                                            InputLabelProps={{ shrink: true }}  
                                            value={edadDesde}
                                            validators={['required', 'matchRegexp:^[0-9]+$', 'maxNumber:150']}
                                            errorMessages={[
                                                'El valor es requerido'
                                                ,'Solo se permiten números positivos enteros'
                                                ,'Máximo valor debe ser menor a 150'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4} >
                                        <TextValidator
                                            style={{minWidth: 237}}
                                            label="Edad Hasta"
                                            name="edadHasta"
                                            onChange={handleInputChange}
                                            className={classes.withoutLabel}
                                            InputLabelProps={{ shrink: true }}  
                                            value={edadHasta}
                                            validators={['required', 'matchRegexp:^[0-9]+$', 'maxNumber:150']}
                                            errorMessages={[
                                                'El valor es requerido'
                                                ,'Solo se permiten números positivos enteros'
                                                ,'Máximo valor debe ser menor a 150'
                                            ]}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="center" justify="center" >
                                    <Grid item xs={12} md={4} >
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog"
                                                label="Fecha Desde"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                required={true}
                                                // minDate={new Date()}
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                // minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
                                                value={fechaDesde}
                                                onChange={(e) => handleInputChange({target: {name: 'fechaDesde', value: e}})}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} md={4} >
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog"
                                                label="Fecha Hasta"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                required={true}
                                                // minDate={new Date()}
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                // minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
                                                value={moment(moment(fechaHasta).format('YYYY-MM-DD')).isSame(moment('3000-12-31')) ? null : fechaHasta}
                                                onChange={(e) => handleInputChange({target: {name: 'fechaHasta', value: e}})}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="center" justify="center" >
                                    <Grid item xs={12} md={4} >
                                        <TextValidator
                                            style={{minWidth: 237}}
                                            label="Importe Cuota"
                                            name="cuota"
                                            onChange={handleInputChange}
                                            className={classes.withoutLabel}
                                            InputLabelProps={{ shrink: true }}  
                                            value={cuota}
                                            validators={['required', 'isPositive']}
                                            errorMessages={['El valor es requerido', 'Solo se permiten números']}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4} >
                                        <TextValidator
                                            style={{minWidth: 237}}
                                            label="Importe Cuota Familiar"
                                            name="cuotaFamiliar"
                                            onChange={handleInputChange}
                                            className={classes.withoutLabel}
                                            InputLabelProps={{ shrink: true }}  
                                            value={cuotaFamiliar}
                                            validators={['required', 'isPositive']}
                                            errorMessages={['El valor es requerido', 'Solo se permiten números']}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={8} className={classes.gridBackground} style={{textAlign: 'right', paddingRight: 50, paddingBottom: 25}}>
                                <Button
                                    style={{marginTop: 25}}
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    startIcon={<SaveIcon />}
                                    type="submit"
                                >
                                    GUARDAR
                                </Button>
                            </Grid>
                        </Grid>
                        {openQuestion && 
                            <AlertFinalizadoStepper
                                open={openQuestion}
                                pregunta={"Modificación de Resolución"}
                                dialogText={"Se van a realizar cambios en la resolución, esto generará cambios en las siguientes facturaciones, está seguro?"}
                                buttonCancel={"Cancelar"}
                                buttonSubmit={"Continuar"}
                                handleClose={() => setOpenQuestion(false)}
                                handleSend={handleSave}
                            />
                        }
                    </ValidatorForm>
                </>
            )}
        </>       
     );
}